import { Row, Col, Card } from "reactstrap";
import { Progressbar } from "../../../../AbstractElements";
import { ProgressBarsAnimated } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { ANIMATED_DATA, ANIMATED_LIST } from "../../../../Data/UiKit/Progress/index";

export const ProgressBarsAnimatedCart = () => {
  return (
    <Col xl="6">
      <Card>
        <CommonCardHeader title={ProgressBarsAnimated} span={ANIMATED_DATA} />
        <Row className="card-body progress-showcase">
          <Col>
            <Progressbar color="primary" striped animated value="10" />
            {ANIMATED_LIST.map(({ color, value }, index) => (
              <Progressbar color={color} striped animated value={value} key={index}/>
            ))}
          </Col>
        </Row>
      </Card>
    </Col>
  );
};
